import { RouteObject } from "react-router-dom";
import CommonEvent from "../pages/EventsPage/components/CommonEvent";
import EventPaymentPageWithLayout from "../pages/EventsPage/components/Payments/EventPaymentPageWithLayout";
import RegistrationSuccess from "../pages/EventsPage/components/Payments/RegistrationSuccess";
import { EventTabGuard } from "../components/Events/EventTabGuard";
import { DelegateRegistration } from "../pages/EventsPage/components/Payments/RegistrationForm";
import StaffRegistrationTab from "../pages/EventsPage/components/StaffRegistrationTab";
import MemberAttendeesTab from "../pages/EventsPage/components/MemberAttendeesTab";
import MemberAccomodationsTab from "../pages/EventsPage/components/MemberAccomodationsTab";
import MemberSpecialEventTab from "../pages/EventsPage/components/MemberSpecialEventTab";
import MemberOverviewTab from "../pages/EventsPage/components/MemberOverviewsTab";
import MemberPhotoGalleryTab from "../pages/EventsPage/components/MemberPhotoGalleryTab";
import MemberContactUsTab from "../pages/EventsPage/components/MemberContactUsTab";
import MemberProgramTab from "../pages/EventsPage/components/MemberProgramTab";
import EventPresentationViewer from "../pages/EventsPage/components/EventPresentationViewer";
import NetworkingMapPage from "../pages/EventsPage/NetworkingMapPage";
import { NetworkingMapRoute } from "../Enums/EventEnums";

export const EventRoutes: RouteObject[] = [
  {
    path: "/events/:id",
    element: (
      <EventTabGuard>
        <CommonEvent />
      </EventTabGuard>
    ),
    children: [
      {
        path: "registration",
        children: [
          {
            index: true,
            element: (
              <StaffRegistrationTab
                isEditMode={false}
                onEditClick={() => {}}
                viewMode="member"
              />
            ),
          },
          {
            path: "form",
            element: <DelegateRegistration />,
          },
          {
            path: "payment",
            element: <EventPaymentPageWithLayout />,
          },
          {
            path: "success",
            element: <RegistrationSuccess />,
          },
        ],
      },
      {
        path: "overview",
        element: <MemberOverviewTab />,
      },
      {
        path: "accommodations",
        element: <MemberAccomodationsTab />,
      },
      {
        path: "special-event",
        element: <MemberSpecialEventTab />,
      },
      {
        path: "gallery",
        element: <MemberPhotoGalleryTab />,
      },
      {
        path: "attendees",
        element: <MemberAttendeesTab />,
      },
      {
        path: NetworkingMapRoute,
        element: <NetworkingMapPage />,
      },
      {
        path: "contact-us",
        element: <MemberContactUsTab />,
      },
      {
        path: "program",
        children: [
          {
            index: true,
            element: <MemberProgramTab />,
          },
          {
            path: "pdf",
            element: <EventPresentationViewer />,
          },
        ],
      },
    ],
  },
];
